/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { useState } from "react";

const useInput = (validateValue: any) => {

    const [regexhasError, setRegexhasError] = useState(false);

    const [enteredValue, setEnteredValue] = useState('');
    const [isTouched, setIsTouched] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const valueIsValid = validateValue(enteredValue);
    const hasError = !valueIsValid && isTouched;
    const onSubmitError = !valueIsValid && isSubmitted;
    const valueChangeHandler = (event: any,regexpassed:RegExp) => {
        setEnteredValue(event.target.value);
        if(regexpassed.test(event.target.value)){
            setRegexhasError(false)
        }
        else{
            setRegexhasError(true)
        }

    }
    const inputBlurHandler = () => {
        setIsTouched(true);
    }
    const reset = () => {
        setEnteredValue('');
        setIsTouched(false);
        setIsSubmitted(false);
    }
    const onSubmitHandler = () =>
    {
        setIsSubmitted(true);
    }
    return {
        value: enteredValue,
        isValid: valueIsValid,
        hasError: hasError,
        onSubmitError,
        valueChangeHandler,
        inputBlurHandler,
        onSubmitHandler,
        reset,
        // manualError : true
        regexError : regexhasError
      };

}

export default useInput;